import {Component, OnInit} from '@angular/core';
import {Router} from '@angular/router';

import {AuthenticationService} from '../_services/authentication.service';

@Component({
    moduleId: module.id,
    templateUrl: 'index.component.html'
})

export class IndexComponent implements OnInit {

    constructor(private authenticationService: AuthenticationService, private router: Router) {
    }

    ngOnInit(): void {
        this.router.navigate([this.authenticationService.getStartUrl()]);
    }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/odQvAFzU/0/heba/118365/src/main/frontend/src/app/index/index.component.ts